import { render } from "./IOT.vue?vue&type=template&id=458460e4&scoped=true"
import script from "./IOT.vue?vue&type=script&lang=js"
export * from "./IOT.vue?vue&type=script&lang=js"

import "./IOT.vue?vue&type=style&index=0&id=458460e4&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458460e4"]])

export default __exports__